import classnames from "classnames";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { useForm, useFormContext, useFormState, useWatch } from "react-hook-form";
import RadioButtonCustomBlendTextFields from "./RadioButtonCustomBlendTextFields";

import "./radioButtonCustomBlend.scss";

const RadioButtonCustomBlend = ({ name, options, fieldIndex, layout, predefined, savedLabel, sendDataToParent }) => {
  const { register, control, getValues, setValue, setError, clearErrors, formState, formData } = useFormContext();
  const currentValue = useWatch({
    control,
    name,
  });

  const { resetField } = useForm({ control });
  const { isDirty, errors } = useFormState({ control });
  const error = errors?.[name]?.message;
  const [dataFromInputFields, setDataFromInputFields] = useState(null);
  const [selectedRadioButton, setSelectedRadioButton] = useState(null);
  const [initialStub, setInitialStub] = useState(false);
  const isLayoutHorizontal = layout === "horizontal";

  const handleRadioClick = (e) => {
    setSelectedRadioButton(e.target.value);
    for(const option of options.options) {
      const optVal = option.value;
      for (const field of option.custBlendFields) {
        resetField(`${optVal}.${field.extAcctCode}.value`);
        document.querySelector(`input[name="${optVal}.${field.extAcctCode}.value"]`).value = "";
      }
    }
  }
  function formatPercentage(integer) {
    return (integer / 100).toFixed(2);
  }

  /* eslint-disable */
  useEffect(() => {
    if(savedLabel && !initialStub) {
      setSelectedRadioButton(savedLabel);
      if(currentValue && currentValue.length !== 1){
        sendDataToParent(JSON.parse(currentValue));
        initialStub = true;
      }
    }
  },[savedLabel]);


  useEffect(() => {
    if(isDirty) {
      const allFormValues = getValues();
      if(!predefined && currentValue && currentValue.length !== 1 && !initialStub) {
        setSelectedRadioButton(savedLabel);
        sendDataToParent(JSON.parse(currentValue));
        setInitialStub(true);
      } else if(!predefined && allFormValues.customBlend) {
        const data = allFormValues[allFormValues.customBlend];
        let result = {};
        for(const key in data) {
          if(data[key].value !== ""){
            result[key] = data[key].value;
          } else {
            result = {};
            break;
          }
        }

        let count = 0;
        for(const key in result) {
          count += parseInt(result[key]);
        }
        
        if(count === 100){ 
          for(const key in result) {
            result[key] = formatPercentage(result[key]);
          }
          //console.log('RESULT IS ' + JSON.stringify(result));
          sendDataToParent(result)
          clearErrors([name]);
        } else {
          sendDataToParent(null);
          if(count !== 0){
            setError(name, { type: "manual", message: "Total percentage must equal 100%" });
          }
        }
      } else if(predefined) { 
        const data = allFormValues[null];
        const result = {};
        for(const key in data) {
          result[key] = formatPercentage(data[key].value);
        }
        sendDataToParent(result);
      }
    }
    
  }, [isDirty, currentValue, dataFromInputFields]);
  /* eslint-enable */
  
  const handleDataFromChild = (data) => {
    setDataFromInputFields(data);
  }

  return (
    <div
      className={classnames("radio-button-group", {
        "radio-button-group__horizontal": !isLayoutHorizontal,
        "radio-button-group__vertical": isLayoutHorizontal,
      })}
      key={fieldIndex}
    >
      {options.options?.map(({ label, subtext, value, custBlendFields, checked }, index) => {
        const optionValue = value;
        return (
          <label
            key={index}
            className={classnames({
              "radio-button-group__option-horizontal": !isLayoutHorizontal,
              "radio-button-group__option-vertical": isLayoutHorizontal,
            })}
          >
            {predefined ? (
              <></>
            ) : (
              <>
                <input
                  name={`${name}-${optionValue}`}
                  type="radio"
                  value={optionValue}
                  checked={selectedRadioButton === optionValue}
                  onClick={handleRadioClick}
                  {...register(`${name}`, { ...(options || {}) })}
                  disabled={options.readOnly}
                />
                <div className="radio-button-group__indicator" />
                <div className="radio-button-group__label">
                  <p>{parse(label)}</p>
                  {subtext && <p>{subtext}</p>}
                </div>
                {errors.name && <p>{errors.name.message}</p>}
              </>
            )}
            
           {custBlendFields && custBlendFields?.length > 0 && (
              <RadioButtonCustomBlendTextFields sendDataToParent={handleDataFromChild} selectedRadioButton={selectedRadioButton} isDisabled={predefined || selectedRadioButton !== optionValue} optionValue={optionValue} custBlendFields={custBlendFields}/>
            )}
          </label>
        );
      })}
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
};

RadioButtonCustomBlend.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
  fieldIndex: PropTypes.string,
  layout: PropTypes.string,
  predefined: PropTypes.bool,
};

export default RadioButtonCustomBlend;